import React,{useState} from 'react'
import axios from 'axios';
import { Link } from "react-router-dom";
import { environment } from '../environment/production';
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";

function UserRegistration() {
  const navigate = useNavigate()

  const recaptchaRef = React.createRef();
    const [recaptcha,setReCaptcha]=useState('')
    const [formdata, setFormData] = useState({
        title:'',
        email_id: '',
        username:'',
        password: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        mobile_number:''
      });
      // const [message, setMessage] = useState({
      //   email: '',
      //   password: '',
      //   first_name: '',
      //   middle_name: '',
      //   last_name: '',
      //   mobile_no:''
      // })
      const options={
        data:{
          formdata
        },
        headers:{
          'Content-type':'application/json'
        }
      }
      const userRegistrationAPI=(e)=>{
        // e.preventDefault();
        //console.log(JSON.stringify(options.data.formdata));
      
           axios.post(environment.apiUrl+`/User/save_data`,JSON.stringify(options.data.formdata),{headers:JSON.stringify(options.headers)})
     .then((response)=>{
      //console.log(response)
         if(response['data']['status']==1){
          // alert(response['data']['msg'])
          alert("Your account has been created successfully. An OTP has been sent to your registered email ID for verification. In case you didn't receive the OTP within a few minutes, please click on Send OTP to request a new one and proceed with the verification process.")
          axios.post(environment.apiUrl+`/User/sendOTP`,JSON.stringify(options.data.formdata),{headers:JSON.stringify(options.headers)})
          .then((response)=>{
          
             if(response['data']['status']=="1"){
              
              
              navigate("/otp",{state:{email:formdata.email_id}})
             }
          })
        //   alert(response['data']['msg'])
        // }else if(response['data']['msg']==undefined){
        // alert(response['data']['msg'])
       
         }else{
          alert(response['data']['msg'])
         }
        
     })
       
   }
   const handleValidation=()=>{
    var re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    var regexpName=/^[a-zA-Z .]+$/;
    
    if(formdata.email_id ===''){
      // setMessage({
      //   email:'Email is required'
      // })
      // message.email="Email is required";
      alert("Email is required")
    }else if(formdata.password ===''){
      // setMessage({
      //   password:'Password is required'
      // })
      //message.password="Password is required";
      alert("Password is required")
    }else if(formdata.first_name ===''){
      //message.first_name="First name is required";
      alert("First name is required")
    }else if(formdata.last_name ===''){
      //message.last_name="Last name is required";
       alert("Last name is required")
    }else if(formdata.mobile_number ===''){
      //message.mobile_no="Mobile no. is required";
      alert("Mobile no. is required")
    }else if(formdata.mobile_number.length!==10){
      alert("Mobile Number Should be 10 digits only")
    }
    else if(recaptcha===''){
      alert("Kindly check google Captcha")
    }else if(!re.test(formdata.password)){
      alert("Password should be min 8 letter password, with at least a symbol, upper and lower case letters and a number")
    }else if(!regexpName.test(formdata.first_name)){
      alert("Only Aphabets Allowed in First Name")
    }
    else if(!regexpName.test(formdata.last_name)){
      alert("Only Aphabets Allowed in Last Name")
    }else{
      if(formdata.email_id !=='' && formdata.password !=='' && formdata.first_name !=='' && formdata.last_name !=='' && formdata.mobile_number !=='' && recaptcha !==''){
        userRegistrationAPI()
      }
    }
    // && formdata.re_captcha !==''
    
   }
   const handleSubmit = (e) => {
   
    e.preventDefault();
  //console.log(e.target.appl_recvd_d.value);
   formdata.email_id=e.target.email.value;
   formdata.password=e.target.password.value;
   
   formdata.first_name=e.target.first_name.value;
   formdata.middle_name=e.target.middle_name.value;
   formdata.last_name=e.target.last_name.value;
   formdata.mobile_number=e.target.mobile_no.value;
   setFormData(...[formdata]);
   
   /* axios api post */
   handleValidation();
   //setMessage(...[message]);
   
 };
  return (
    <>
 <div className="login-page login-page9" style={{height:'100%'}}>  {/* style={{ backgroundImage: `url('./gstn.png')` }} */}
     <div className="login-page9-wrapper" style={{paddingTop:'2%',paddingBottom:'1%',gap:'0px'}}>
     <h5 className="text-center">GSTAT Retiree Application Portal</h5>
     {/* <marquee behavior="" direction="left"><h3>Submission of applications for the posts of staff and Officers of GSTAT has temporarily been kept on hold. The facilty may be re-opened based on processing of the applications received and ascertainment of posts remaining vacant, if any.</h3></marquee> */}
     <h4 style={{textAlign:'center'}}>USER REGISTRATION</h4>
     
      <form onSubmit={handleSubmit}>
                
                <label className="rlp-firstname">
                    <input type="text" placeholder="First Name" index="5" name="first_name" style={{height:'50px'}}/>
                </label>
           
                <label className="rlp-middlename">
                    <input type="text" placeholder="Middle Name" index="6" name="middle_name"  style={{height:'50px'}}/>
                </label>
           
                <label className="rlp-lastname">
                    <input type="text" placeholder="last Name" index="7" name="last_name"  style={{height:'50px'}}/>
                </label>
                
          <label className="rlp-username">
            <input type="email" placeholder="Email" index="1" name="email"  style={{height:'50px'}}/>
          </label><label className="rlp-password">
          <input type="password" placeholder="Password" index="2"name="password"  style={{height:'50px'}} />
          </label>
          {/* <label className="rlp-cpassword">
            <input placeholder="Confirm Password" index="3" name="email"/>
          </label> */}
          <label className="rlp-mobileno">
          <input type="number" placeholder="Mobile Number" index="4" name="mobile_no"  style={{height:'50px'}} />
          </label>
          <label className="re-captcha">
          <ReCAPTCHA ref={recaptchaRef} sitekey={environment.recaptcha.siteKey} name="re_captcha" onChange={(value)=>setReCaptcha(value)} />
          </label>
          <section>
          
          <button type="submit">SIGN UP</button>
          </section>
           
      </form>
      
      </div>
      
    </div>
    
    </>
  )
}

export default UserRegistration